import ReactMarkdown from 'react-markdown'
import styled, { css } from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

export const StyledReactMarkdown = styled(ReactMarkdown)<{ twoCols: boolean }>`
  color: #2e3333;
  width: 100%;
  overflow: hidden;
  font-size: 15px;
  line-height: 1.4;

  ${props =>
    props.twoCols &&
    css`
      @media (min-width: ${breakpoints.wideDesktop}px) {
        column-count: 2;
        column-gap: 8%;
        padding-bottom: 100px;
      }
    `}

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.3;
    margin: 24px 0 16px 0;

    &:first-child {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 18px;
  }

  h4 {
    font-size: 16px;
  }

  h5 {
    font-size: 15px;
    font-weight: 400;
  }

  h6 {
    font-size: 14px;
    font-weight: 400;
  }

  p {
    font-size: 15px;
    font-weight: 400;
    line-height: 1.6;
    margin: 0 0 16px 0;
  }

  a {
    color: #2e3333;
    font-weight: 700;
    text-decoration: underline;
  }

  blockquote {
    margin: 0 0 16px 0;
    padding: 8px 16px;
    border-left: 3px solid #d1d5d5;

    > p {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    font-size: 15px;
    line-height: 1.6;
    margin: 0 0 16px 0;
    padding-left: 24px;
  }

  li {
    margin-bottom: 4px;

    > ul,
    > ol {
      margin-top: 4px;
      margin-bottom: 0;
    }
  }

  li::marker {
    font-weight: 700;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  hr {
    border: none;
    border-top: 1px solid #d1d5d5;
    margin: 24px 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  code {
    font-size: 13px;
    background: #f0f2f2;
    padding: 2px 6px;
    border-radius: 3px;
  }

  pre {
    margin: 0 0 16px 0;
    padding: 12px 16px;
    background: #f0f2f2;
    border-radius: 4px;
    overflow-x: auto;

    code {
      padding: 0;
      background: none;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 16px 0;
    font-size: 14px;
  }

  th,
  td {
    padding: 8px 12px;
    border: 1px solid #d1d5d5;
    text-align: left;
  }

  th {
    font-weight: 700;
    background: #f0f2f2;
  }
`
